import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import GoogleLogin from 'react-google-login';
import Cookie from 'universal-cookie';
import { checkJWTAuth, parseSearch, environment } from '../../../utils';
import { useHistory, useLocation } from 'react-router-dom';

const cookie = new Cookie();
const CLIENT_ID = environment.REACT_APP_OAUTH_CLIENT_ID;

const Container = styled.div`
  display: block;

  i,
  button {
    display: block;
  }
`;

const Login = styled(GoogleLogin)`
  padding: 1rem 1.5rem;
  margin: 1rem 0;
  font-size: 1rem;
  background-color: ${(p) => p.theme.color.pink100};
  color: ${(p) => p.theme.color.white100};
  outline: none;
  border: none;
  cursor: pointer;
`;

const Error = styled.i`
  color: ${(p) => p.theme.color.turquoise100};
  margin: 1rem 0;
`;

const LoginPage = () => {
  const [error, setError] = useState('');
  const history = useHistory();
  const location = useLocation(); // <--- get current location (for search params)

  const responseGoogle = async (resp) => {
    console.log(resp);
    if (resp.error) {
      console.log('Login error.');
      cookie.remove('jwt');
      setError(resp.error);
      return;
    }

    const { search } = location;
    const params = parseSearch(search);
    const next = params.next || '/admin';

    const id_token = resp.tokenId;
    const ok = await checkJWTAuth(id_token);
    if (ok) {
      cookie.set('jwt', id_token);
      history.push(next);
    } else {
      cookie.remove('jwt');
      console.log('Backend auth verification failed.');
      setError('Backend auth verification failed.');
    }
  };

  useEffect(() => {
    const jwt = cookie.get('jwt');
    if (jwt) {
      responseGoogle({ tokenId: jwt });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // ^ Only runs once on mount (like constructor + componentDidMount combined)

  const onLogin = async (resp) => {
    await responseGoogle(resp);
    window.location.reload();
  };

  return (
    <Container>
      <h2>Log in to Radiodiodi admin</h2>
      <i>Use your Radiodiodi.fi domain email.</i>
      <Login
        clientId={CLIENT_ID}
        buttonText="Log in"
        onSuccess={onLogin}
        onFailure={onLogin}
        hostedDomain="radiodiodi.fi"
        responseType="jwt"
        signedIn
      />
      {error && <Error>Error: {error}</Error>}
    </Container>
  );
};

export default LoginPage;
